import { Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEmptyTable extends Layout {
    tableEmptyMoves: Table;
}
